export default __webpack_public_path__ + "transfix-maps/icons/P1.4c7b76abd3824a0555be915f035e89c2.png";